// Ширината на потвърждаващия диалог — класът „Default" от modals.md (въпросът
// носи преглед на последствията, затова не е тесният „Compact"): 460 десктоп,
// 420 таблет, на телефон — ширината на екрана минус 32px (modalWrapStyle).
export const confirmDialogWidth = (viewport: { isMobile: boolean; isTablet: boolean }) =>
  viewport.isMobile ? undefined : viewport.isTablet ? 420 : 460;
